import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import Invoice from "./Invoice";
import TermAndCondition from "./TermAndCondition";
import axios from "axios";
import API_URL from "../config";
import { useAdmin } from "../contexts/AdminContext";

const CustomDropdown = ({ options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="custom-dropdown" ref={dropdownRef} style={{ margin: 0 }}>
      <button
        type="button"
        className="dropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: "10px",
          border: "1px solid gray",
          borderRadius: 5,
        }}
      >
        {value || "Select Invoice Type"}
      </button>
      {isOpen && (
        <ul className="dropdown-options">
          {options.map((option) => (
            <li key={option} onClick={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const GymTable = ({
  data,
  allexpired,
  isEdit,
  isDelete,
  isInvoice,
  isAll,
  from,
  isAgreement,
  onDeleteSuccess,
  trainer,
  view,
}) => {
  const { admin } = useAdmin();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [contactsNumbers, setContactNumbers] = useState(null);
  const [selectedAgreementMember, setSelectedAgreementMember] = useState(null);
  const [showPrintButton, setShowPrintButton] = useState(false);
  const [gstDetails, setGstDetails] = useState([]);

  const [terms, setTerms] = useState([]);
  const [terminationConditions, setTerminationConditions] = useState([]);
  const [warningMessage, setWarningMessage] = useState("");

  useEffect(() => {
    fetchTerms();
    fetchGstDetails();
    fetchTerminationConditions();
    fetchContacts();
  }, []);

  const fetchTerminationConditions = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/termination/${admin?.branch}`
      );
      if (response.data) {
        setTerminationConditions(response.data.conditions);
        setWarningMessage(response.data.warningMessage);
      }
    } catch (error) {
      console.error("Error fetching termination conditions:", error);
    }
  };

  const fetchContacts = async () => {
    try {
      const response = await axios.get(`${API_URL}/contact/${admin?.branch}`);
      setContactNumbers(response.data.data);
    } catch (error) {
      console.error("Error fetching contact data");
    }
  };

  const fetchGstDetails = async () => {
    try {
      const response = await axios.get(`${API_URL}/gst/get/${admin?.branch}`);
      if (response.data) {
        setGstDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching GST data:", error);
    }
  };

  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${API_URL}/terms/${admin?.branch}`);
      if (response.data && response.data.content) {
        setTerms(response.data.content);
      }
    } catch (error) {
      console.error("Error fetching terms and conditions:", error);
    }
  };

  const invoiceRef = useRef();
  const aggreementRef = useRef();

  const itemsPerPage = 10;
  const navigate = useNavigate();

  const deleteMember = async (memberId) => {
    try {
      const response = await fetch(
        `${API_URL}/auth/${memberId}/${admin.branch}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        alert("Member deleted successfully!");
        onDeleteSuccess();
      } else {
        alert("Error deleting member!");
      }
    } catch (error) {
      alert("Please try again!");
    }
  };

  const filteredData = allexpired
    ? data.filter((item) => new Date() > new Date(item.renewalExpiryDate))
    : data;

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = isAll
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleEdit = (id) => {
    let editRoute = "/";
    switch (from) {
      case "userManagement":
        editRoute = `/admin/usermanagement/edituser/${id}`;
        break;
      case "membershipManagement":
        editRoute = `/admin/membershipmanagement/editmembership/${id}`;
        break;
      case "dietPlanManagement":
        editRoute = `/admin/dietplanmanagement/editdiet/${id}`;
        break;
      case "exerciseManagement":
        editRoute = `/admin/exercisemanagement/editexercise/${id}`;
        break;
      default:
        editRoute = "/";
    }
    navigate(editRoute);
  };

  // useEffect(() => {
  //   if (selectedAgreementMember) {
  //     setTimeout(() => {
  //       if (aggreementRef.current) {
  //         aggreementRef.current.handleDownloadPdf();
  //       }
  //     }, 100);
  //   }
  // }, [selectedAgreementMember]);

  const handlePrintInvoice = () => {
    if (selectedMember && invoiceRef.current) {
      invoiceRef.current.handleDownloadPdf();
    }
  };

  const handleInvoiceTypeSelection = (option, member) => {
    setSelectedInvoice(option);
    setSelectedMember(member);
    setShowPrintButton(true);
  };

  const handlePrintAgreement = (user) => {
    setSelectedAgreementMember(user);
  };

  return (
    <div className="table-container">
      <table className="custom-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Phone Number</th>
            <th>Mail ID</th>
            <th>Renewal Status</th>
            {isEdit && <th>Edit</th>}
            {isDelete && <th>Delete</th>}
            {isInvoice && <th>Invoice</th>}
            {isAgreement && <th>Agreement</th>}
            {trainer && <th>Trainer</th>}
            {view && <th style={{ textAlign: "center" }}>View Details</th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((item) => {
              const currentDate = new Date();
              const renewalExpiryDate = new Date(item.renewalExpiryDate);
              const isExpired = currentDate > renewalExpiryDate;

              return (
                <tr key={item.memberId}>
                  <td>{item.memberId}</td>
                  <td>{item.fullName}</td>
                  <td>{item.phoneNo}</td>
                  <td>{item.email}</td>
                  <td
                    className={isExpired ? "status-expired" : "status-active"}
                  >
                    <span className="status-indicator"></span>
                    {isExpired ? "Expired" : "Active"}
                  </td>
                  {isEdit && (
                    <td
                      className="editBtnGymTable"
                      onClick={() => handleEdit(item.memberId)}
                    >
                      <TbEdit style={{ cursor: "pointer" }} />
                    </td>
                  )}
                  {isDelete && (
                    <td
                      className="deleteBtnGymTable"
                      onClick={() => deleteMember(item.memberId)}
                    >
                      <RiDeleteBin6Line />
                    </td>
                  )}
                  {isInvoice && (
                    <td className="invoiceBtnGymTable">
                      <CustomDropdown
                        options={["With GST", "Without GST"]}
                        value={selectedInvoice}
                        // onChange={setSelectedInvoice}
                        onChange={(option) =>
                          handleInvoiceTypeSelection(option, item)
                        }
                      />
                    </td>
                  )}
                  {isAgreement && (
                    <td className="agreementPrint">
                      <button
                        onClick={() => handlePrintAgreement(item)}
                        disabled={!item?.isAgreementAccepted}
                      >
                        Print
                      </button>
                      {!item?.isAgreementAccepted && (
                        <p style={{ color: "#ff0000" }}>Not agreed yet.</p>
                      )}
                    </td>
                  )}
                  {trainer && <td>{item?.trainerId || "N/A"}</td>}
                  {view && (
                    <td
                      onClick={() =>
                        navigate("/admin/membershipmanagement/viewdetail", {
                          state: { item },
                        })
                      }
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      View
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                style={{
                  textAlign: "center",
                  margin: "10px 0",
                  fontSize: 16,
                  color: "#ff0000",
                }}
                colSpan={isAgreement ? 6 : 5}
                className="no-data"
              >
                No users found!
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {!isAll && (
        <div className="pagination">
          <button
            className="pagination-btn"
            onClick={goToPrevPage}
            disabled={currentPage === 1}
          >
            <FaChevronLeft />
          </button>
          <span className="pagination-text">
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="pagination-btn"
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
          >
            <FaChevronRight />
          </button>
        </div>
      )}
      {showPrintButton && (
        <div>
          <button
            onClick={handlePrintInvoice}
            className="dietPlanSaveBtn"
            style={{ margin: 0, marginTop: 20, padding: 10 }}
          >
            Print Invoice {selectedInvoice}
          </button>
        </div>
      )}

      {selectedMember && (
        <Invoice
          ref={invoiceRef}
          memberData={selectedMember}
          invoiceType={selectedInvoice}
          gstDetails={gstDetails}
          contactsNumbers={contactsNumbers}
        />
      )}

      {selectedAgreementMember && (
        <TermAndCondition
          ref={aggreementRef}
          user={selectedAgreementMember}
          terms={terms}
          terminationConditions={terminationConditions}
          warningMessage={warningMessage}
        />
      )}
    </div>
  );
};

export default GymTable;
